import React from 'react'
import styled from 'styled-components';
import EmailSignupForm from './EmailSignupForm';
import { Col } from 'antd';
import UI from '../../shared/Components/UI/js';

const EmailSignup = ({ _this }) => {
  return (
    <StyledImage image={UI.BG_BLUE_MWELL}>
      <Col className='w-full h-full flex justify-center items-center'>
        <LoginContainer className='bg-white'>
          <EmailSignupForm _this={_this}/>
        </LoginContainer>
      </Col>
    </StyledImage>
  )
}

export default EmailSignup

const StyledImage = styled(`div`)`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 0;
  background-image: ${(props) => `url(${props.image})`};
`;

const LoginContainer = styled(`div`)`
  border-radius: 10px;
  padding: 47px 32.3px 53px 47px;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 571px;
  width: 100%;
  float: none;
  display: inline-block;
  vertical-align: top;
`;
